import type { PropertyId } from '@previo/codebooks'
import { resolveP1PropertyDetailUrl, resolveP1Url } from '~/http/URLUtils'

type PropertySearchNavigation = {
  propertyDetailUrl: (propertyId: PropertyId) => string
  propertyListUrl: (keyword: string) => string
}

export const usePropertySearchNavigation = (): PropertySearchNavigation => {
  const propertyDetailUrl = (propertyId: PropertyId): string => {
    return resolveP1PropertyDetailUrl(propertyId)
  }

  const propertyListUrl = (keyword: string): string => {
    return resolveP1Url('/hotels', {}, { q: keyword.trim() })
  }

  return { propertyDetailUrl, propertyListUrl }
}
